import React, { useState } from "react";

function CustomInput({
  label = "",
  placeholder = "",
  type = "text",
  value,
  onChange,
  icon,
}) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="w-full flex items-center gap-3">
      {label && (
        <label className="text-sm font-semibold text-base-content/70 whitespace-nowrap">
          {label}
        </label>
      )}

      <div
        className={`
          flex items-center gap-3 px-4 py-2 rounded-xl transition-all duration-300 
          bg-base-100/80 backdrop-blur-sm border 
          ${
            isFocused
              ? "border-info ring-2 ring-info/40 shadow-md"
              : "border-base-300"
          }
          flex-1
        `}
      >
        {icon && <span className="text-info">{icon}</span>}

        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className="flex-1 bg-transparent outline-none border-none text-base-content placeholder-base-content/50 font-normal"
        />
      </div>
    </div>
  );
}

export default React.memo(CustomInput);
